/**
 * Krisar Vastrae - Curtain Page Preloader Animation
 * Handles window load completion, curtain reveal, scroll unlock, and clean DOM removal.
 */
(function () {
  'use strict';

  function initCurtainPreloader() {
    const preloader = document.getElementById('site-preloader');
    if (!preloader) {
      document.documentElement.classList.remove('loading');
      return;
    }

    // If preloader is disabled or already transitioning, skip
    if (preloader.classList.contains('is-disabled-editor') || preloader.dataset.animating === 'true') {
      if (preloader.classList.contains('is-disabled-editor')) {
        preloader.style.display = 'none';
        document.documentElement.classList.remove('loading');
      }
      return;
    }

    preloader.dataset.animating = 'true';

    // Generate floating ambient particles
    function createParticles() {
      let container = preloader.querySelector('.preloader-particles');
      if (!container) {
        container = document.createElement('div');
        container.className = 'preloader-particles';
        preloader.insertBefore(container, preloader.querySelector('.curtain-centerpiece'));
      }
      container.innerHTML = '';

      const isMobile = window.innerWidth <= 768;
      const count = isMobile ? 6 : Math.floor(Math.random() * 5) + 10; // 10 to 14

      for (let i = 0; i < count; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';

        const size = (Math.random() * 3 + 2).toFixed(1); // 2px to 5px
        const left = (Math.random() * 100).toFixed(2);
        const top = (Math.random() * 100).toFixed(2);
        const duration = (Math.random() * 4 + 4).toFixed(2); // 4s to 8s
        const delay = (Math.random() * 3).toFixed(2); // 0s to 3s

        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.left = `${left}%`;
        particle.style.top = `${top}%`;
        particle.style.setProperty('--duration', `${duration}s`);
        particle.style.setProperty('--delay', `${delay}s`);

        container.appendChild(particle);
      }
    }

    createParticles();

    const durationSec = parseFloat(preloader.dataset.duration || '1.2');
    const delaySec = parseFloat(preloader.dataset.delay || '0.2');
    const durationMs = durationSec * 1000;
    const delayMs = delaySec * 1000;

    let hasRevealed = false;

    function revealPage() {
      if (hasRevealed) return;
      hasRevealed = true;

      // Step 1: Fade out centerpiece logo
      preloader.classList.add('is-closing');

      // Step 2: Trigger curtain slide opening after configured delay
      const openDelay = Math.max(120, delayMs);
      setTimeout(function () {
        preloader.classList.add('is-opening');

        // Step 3: Unlock scroll smoothly during reveal
        setTimeout(function () {
          document.documentElement.classList.remove('loading');
        }, Math.min(250, durationMs * 0.25));

        // Step 4: Completely remove element from DOM after transition completes
        setTimeout(function () {
          if (preloader && preloader.parentNode) {
            preloader.parentNode.removeChild(preloader);
          }
        }, durationMs + 100);
      }, openDelay);
    }

    // Execute on full window load (when hero images, fonts, styles are ready)
    if (document.readyState === 'complete') {
      setTimeout(revealPage, 60);
    } else {
      window.addEventListener('load', function () {
        setTimeout(revealPage, 60);
      });
    }

    // Fallback safety timeout (4.5s) to guarantee curtains always open even if 3rd party scripts hang
    setTimeout(revealPage, 4500);
  }

  // Initialize when DOM is available
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCurtainPreloader);
  } else {
    initCurtainPreloader();
  }

  // Shopify Theme Editor (Customizer) live lifecycle support
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('#site-preloader') || event.target.id === 'site-preloader') {
      initCurtainPreloader();
    }
  });
})();
